const intlNumberFormat = new Intl.NumberFormat("ru-RU", {
  minimumFractionDigits: 0,
  maximumFractionDigits: 3
})

export const spaceNumber = (number?: number | string) => {
  if (!number) return "0"

  if (typeof number === "string") {
    const n = parseFloat(number)
    number = n ? n : 0
  }

  return intlNumberFormat.format(number).replace(",", ".")
}
